import s from './styles';
import CardWorker from './CardEmployees';

function WorkerCards({
  workers,
  setWorkerToEdit,
  setAddWorkerModalOpen,
  onDeleteRequest,
}) {
  return (
    <s.Container>
      <s.TableContainer>
        {workers.map((item) => (
          <CardWorker
            key={item._id}
            item={item}
            setWorkerToEdit={setWorkerToEdit}
            setAddWorkerModalOpen={setAddWorkerModalOpen}
            onDeleteRequest={onDeleteRequest}
            setWorkerDelete={onDeleteRequest}
          />
        ))}
      </s.TableContainer>
    </s.Container>
  );
}

export default WorkerCards;
